module.exports = __webpack_public_path__ + "img/minish-cap.4ada1024.jpg";